import moment from 'moment';

export class MerchantListRequest {
    constructor(params) {
        this.pageNumber = params.pageIndex ?? 1;
        this.pageSize = params.pageSize ?? 10;
        this.sort = 'createdOn';
        this.entityType = 'MERCHANT';
        this.enterpriseMerchant = true;
        this.axisMid = params.axisMid ?? null;
        this.createdBy = params.createdBy ?? null;
        this.mode = params.mode ?? null;
        this.source = params.source ?? null;
        this.merchantId = params.merchantName ?? null;
        this.status = params.status ?? 'ACTIVE';
        this.registeredEmail = params.registeredEmail ?? null;
        this.mobile = params.mobile ?? null;
        this.partnerId = params.partnerId ?? null;
        this.merchantVpa = params.merchantVpa ?? null;
        this.mleId = params.mleName ?? null;

        if (params.createdOn?.startDate && params.createdOn?.endDate) {
            this.startDate = moment(params.createdOn.startDate).startOf('day').format('YYYY-MM-DD HH:mm:ss');
            this.endDate = moment(params.createdOn.endDate).endOf('day').format('YYYY-MM-DD HH:mm:ss');
        } else {
            this.startDate = null;
            this.endDate = null;
        }
    }
}
